/**
 * @param {Object} worker
 * @param {number} worker.id
 * @param {number} worker.pid
 * @param {string} worker.created
 * @param {string} worker.modified
 * @param {boolean} worker.terminate
 * @param {string=} worker.job_type
 * @param {boolean} disabled
 * @param {function} onTerminate
 */
import React, { useCallback, useMemo } from "react";
import Badge from "../../theme/untitled/Badge/Badge";
import Icon from "../../theme/untitled/icons/Icon";
import RowActionsMenu from "../../theme/untitled/RowActionsMenu/RowActionsMenu";
import { formatter_ymdhms } from "../../../../helpers/formatters";
import styles from "./QueueWorkersPage.module.scss";

const JOB_TYPE_LABELS = {
  Email: "Email",
  SyncOne: "Sync One",
  ICSUpdate: "ICS Update",
  ICSDelete: "ICS Clean",
  Integration: "Sync",
};

const TableRow = ({ worker, disabled, onTerminate }) => {
  const { id, created, modified, terminate, pid, job_type } = worker;

  const onTerminateClick = useCallback(
    () => onTerminate(id),
    [onTerminate, id]
  );

  const menuOptions = useMemo(
    () => [
      {
        key: "terminate",
        label: "Schedule for termination",
        icon: <Icon name="Trash01" size={20} />,
        destructive: true,
        onClick: onTerminateClick,
      },
    ],
    [onTerminateClick]
  );

  const statusBadge = terminate ? (
    <Badge color="gray" size="sm" dot>
      Terminated
    </Badge>
  ) : (
    <Badge color="success" size="sm" dot>
      Running
    </Badge>
  );

  return (
    <tr className={styles.row}>
      <td className={styles.idCell}>{id}</td>
      <td className={styles.idCell}>{pid}</td>
      <td>{JOB_TYPE_LABELS[job_type] || "Sync"}</td>
      <td className={styles.dateCell}>
        {formatter_ymdhms.format(new Date(created))}
      </td>
      <td className={styles.dateCell}>
        {formatter_ymdhms.format(new Date(modified))}
      </td>
      <td>{statusBadge}</td>
      <td>
        <RowActionsMenu items={menuOptions} disabled={disabled} />
      </td>
    </tr>
  );
};

export default TableRow;
